import { ZoneResult } from '@app/shared/models';
import { pipe, startWith, map } from 'rxjs';

export function zoneAutocompleteFilter(zones: ZoneResult[]) {
  return pipe(
    startWith(''),
    map(value => value || ''),
    map((value: string | ZoneResult) => typeof value === 'string' ? value : value.displayZoneName),
    map(value => zones.filter(zone => zone.displayZoneName.toLowerCase().includes(value.toLowerCase())))
  );
}
